import {
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Input,
  useColorModeValue,
  Button,
  useToast,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import MultiSelect from 'components/autocomplete/autocomplete';
import moment from 'moment';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { ViewIcon } from '@chakra-ui/icons';
// Custom components
import OrderApi from 'api/orders';
import { OrderStatusOptions, OrderTypeOptions } from 'config/constant';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';
import { isValidUUID } from 'utils/fetchUtils';
import DashboardReportApi from 'api/dashboardreport';

//Remove when API sends Data
export default function CheckTable(props) {
  const withId = props.withId;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  // const [data, setData] = useState([]);
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState();
  const [filterEndDate, setFilterEndDate] = useState();
  const { getPermissionsForModule } = usePermissions();
  const [ordersPermissions, setOrdersPermissions] = useState(null);
  const [fetchOrderListError, setFetchOrderListError] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const customerId = useMemo(() => IdFromUrl(window.location.href), []);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }
  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (800ms)
  };

  const handleDebouncedStartDate = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      setFilterStartDate(value); // Update state after debounce
    }, 800); // Debounce delay
  };

  const handleDebouncedEndDate = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      setFilterEndDate(value); // Update state after debounce
    }, 800); // Debounce delay
  };

  const selectedStatusTypeValue = Array.isArray(selectedStatusType)
    ? selectedStatusType?.map((option) => option.value).join(',')
    : selectedStatusType.value;

  const selectedOrderTypeValue = Array.isArray(selectedOrderType)
    ? selectedOrderType?.map((option) => option.value).join(',')
    : selectedOrderType.value;

  // console.log(
  //   'from order to check multiselect',
  //   selectedOrderTypeValue,
  //   selectedStatusTypeValue
  // );

  const FetchOrderList = async () => {
    if (withId && !isValidUUID(customerId)) {
      setFetchOrderListError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await OrderApi.List(
        withId
          ? {
            currentPage,
            itemsPerPage,
            sort: 'name:asc',
            searchTerm,
            selectedStatusTypeValue,
            selectedOrderTypeValue,
            filterStartDate,
            filterEndDate,
            customerId,
          }
          : {
            currentPage,
            itemsPerPage,
            sort: 'name:asc',
            searchTerm,
            selectedStatusTypeValue,
            selectedOrderTypeValue,
            filterStartDate,
            filterEndDate,
          }
      );
      response = response.data;
      // console.log('Response from orderapi', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchOrderListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchOrderListError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchOrderListError(true);
      console.log(err);
      setList([]);
    }
  };

  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceOrderId, setInvoiceOrderId] = useState(null); // Track which order's invoice is loading

  const toastIdRef = useRef();

  const FetchInvoice = async (id) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      setInvoiceLoading(true);
      setInvoiceOrderId(id);
      let response = await OrderApi.GetInvoice(id);
      response = response.data;
      setInvoiceLoading(false);
      setInvoiceOrderId(null);
      if (response.status_code === 200) {
        window.open(response?.data?.read_url, '_blank');
      } else {
        toastIdRef.current = toast({
          title: response?.message || 'Unable to Generate Invoice, please try again in few moments..',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      setInvoiceLoading(false);
      setInvoiceOrderId(null);
      toastIdRef.current = toast({
        title: 'Unable to Generate Invoice, please try again in few moments..',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };


  useEffect(() => {
    const ordersPermissions = getPermissionsForModule([Modules.Orders]);
    setOrdersPermissions(ordersPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    DashboardReportApi.Notifications();
  }, [])

  useEffect(() => {
    if (ordersPermissions?.read) {
      FetchOrderList();
    }
  }, [
    searchTerm,
    currentPage,
    selectedStatusTypeValue,
    selectedOrderTypeValue,
    filterStartDate,
    filterEndDate,
    customerId,
    ordersPermissions,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    searchTerm,
    selectedStatusTypeValue,
    selectedOrderTypeValue,
    filterStartDate,
    filterEndDate,
  ]);

  // console.log('List conatis', list);

  if (!ordersPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Orders} />;
  }

  return fetchOrderListError ? (
    <PageError />
  ) : (
    <>
      <Flex
        mt={withId ? '0px' : '8rem'}
        px={withId ? '0px' : '25px'}
        justify='left'
        mb='20px'
        align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'></Text>
        <Flex
          direction='column'
          gap={4}
          pt={5}>
          <Flex
            direction={{ base: 'column', '2xl': 'row' }}
            gap={4}>
            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={4}>
              <Flex>
                <Input
                  variant='auth'
                  type='number'
                  minWidth='150px'
                  placeholder='Search By Order No.'
                  onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
                />
              </Flex>
              <Flex>
                <MultiSelect
                  options={OrderStatusOptions}
                  placeholder='Select Status'
                  value={selectedStatusType}
                  onChange={setSelectedStatusType}
                  isMulti={true}
                />
              </Flex>
              <Flex>
                <MultiSelect
                  options={OrderTypeOptions}
                  isMulti={true}
                  placeholder='Select Order Type'
                  value={selectedOrderType}
                  onChange={setSelectedOrderType}
                />
              </Flex>
            </Flex>

            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={2}>
              <Flex gap={2}>
                <Center>From</Center>
                <Input
                  // variant='auth'
                  placeholder='Start Date'
                  type='date'
                  max={filterEndDate || today} // Restrict to end date or today, whichever is earlier
                  value={filterStartDate}
                  onChange={(e) => handleDebouncedStartDate(e.target.value)} // Debounce the update
                />
              </Flex>
              <Flex gap={2}>
                <Center>to</Center>
                <Input
                  // variant='auth'
                  placeholder='End Date'
                  type='date'
                  min={filterStartDate} // Ensure the end date is not before the start date
                  max={today} // Prevent selection of future dates
                  value={filterEndDate}
                  onChange={(e) => handleDebouncedEndDate(e.target.value)} // Debounce the update
                />
              </Flex>
            </Flex>
          </Flex>
          {/* <AddModal
            Icon={<AddIcon />}
            head={'Add Customer Admin User'}
            func={FetchOrderList}
          /> */}
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Order No.
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Name
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Created at
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Order Type
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Total Amount
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  justifyContent='center'
                  // backgroundColor='red'
                  width='100px'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.code}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        size='sm'
                        fontWeight='700'
                        color={textColor}>
                        {moment(obj.created_at).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        fontSize='sm'
                        fontWeight='700'>
                        {
                          OrderTypeOptions.find(
                            (option) => option.value === obj?.order_type
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        fontSize='sm'
                        fontWeight='700'
                        color={
                          obj.status === 'COMPLETED'
                            ? 'green'
                            : obj.status === 'FAILED'
                              ? 'red'
                              : { textColor }
                        }>
                        {OrderStatusOptions.find(
                          (option) => option.value === obj?.status
                        )?.label}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.total_amount}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex justify="left" gap={2}>
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/order/${obj.id}`,
                          }}
                        >
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                      {obj.status === "COMPLETED" && (
                        <Button
                          ml={2}
                          colorScheme="green"
                          variant="outline"
                          size="sm"
                          isLoading={invoiceLoading && invoiceOrderId === obj.id}
                          onClick={() => FetchInvoice(obj.id)}
                        >
                          <Text fontWeight="bold">View Invoice</Text>
                        </Button>
                      )}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
}
